export default "__VITE_ASSET__BmB6tzx$__"